import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: '"SF Pro Display", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
      fontFamily: '"SF Pro Display", "Helvetica", "Arial", sans-serif',
    },
    h2: {
      fontWeight: 600,
      fontFamily: '"SF Pro Display", "Helvetica", "Arial", sans-serif',
    },
    h3: {
      fontWeight: 600,
      fontFamily: '"SF Pro Display", "Helvetica", "Arial", sans-serif',
    },
    h4: {
      fontWeight: 600,
      fontFamily: '"SF Pro Display", "Helvetica", "Arial", sans-serif',
    },
    h5: {
      fontWeight: 600,
      fontFamily: '"SF Pro Display", "Helvetica", "Arial", sans-serif',
    },
    h6: {
      fontWeight: 600,
      fontFamily: '"SF Pro Display", "Helvetica", "Arial", sans-serif',
    },
    button: {
      textTransform: 'none',
      fontWeight: 500,
      fontFamily: '"SF Pro Display", "Helvetica", "Arial", sans-serif',
    },
    body1: {
      fontFamily: '"SF Pro Display", "Helvetica", "Arial", sans-serif',
    },
    body2: {
      fontFamily: '"SF Pro Display", "Helvetica", "Arial", sans-serif',
    },
  },
});

export default theme;
